/* eslint-disable import/prefer-default-export */
import axios from "axios";

// Utility function to get CSRF token from meta tag
const getCSRFToken = () => {
  const metaTag = document.querySelector('meta[name="csrf-token"]');
  if (!metaTag) {
    console.warn(
      "CSRF token meta tag not found. Make sure csrf_meta_tag() is included in the layout."
    );
    return null;
  }
  return metaTag.getAttribute("content");
};

const updateLastRead = async () => {
  const data = await axios
    .put(`/api/update-last-read`, {})
    .then((response) => response.data)
    .catch((err) => {
      console.log("Update last read error");
      console.log(err);
      return {};
    });
  return data;
};

export const postUserFeedback = async (values) => {
  const data = await axios
    .put(`/api/put-user-feedback`, values)
    .then((response) => response.data)
    .catch((err) => {
      console.log("Put user feedback error");
      console.log(err);
      return {};
    });
  return data;
};

export const postUserFeedbackDismissal = async (values) => {
  const data = await axios
    .put(`/api/put-user-feedback-dismissal`, values)
    .then((response) => response.data)
    .catch((err) => {
      console.log("Put user feedback dismissal error");
      console.log(err);
      return {};
    });
  return data;
};
export const updateLastReadDate = () => updateLastRead();

export const trackEvent = async (eventData, pathName) => {
  return axios
    .post(`/api/metrics/${pathName}`, { eventData })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.error("Mixpanel Event tracking error");
      console.error(e);
      return e.message;
    });
};

export const postHolidayRequestForm = async (holidayData) => {
  return axios
    .post(`/api/holiday/request`, { holidayData })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.error(e);
      throw e;
    });
};

export const fetchHolidayHistory = async () => {
  return axios
    .get("/api/holiday/history")
    .then((res) => {
      return res;
    })
    .catch((e) => {
      console.error("Error:", e.message);
      throw e.message;
    });
};

export const postRefereesDetails = (details) => {
  return axios
    .post(`/api/post-referees-details`, { details })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.log("Error");
      console.log(e);
      return e.message;
    });
};

export const postGeneralConsent = async () => {
  return axios
    .post(`/api/consent`)
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.error("Error:", e.message);
      return e.message;
    });
};

export const putTimesheet = async (timesheet, submitted) => {
  return axios
    .put(`/api/timesheets`, { timesheet, submitted })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.error("Error:", e.message);
      return e.message;
    });
};

export const getTimesheets = async () => {
  return axios
    .get("/api/timesheets")
    .then((res) => {
      return res;
    })
    .catch((e) => {
      console.error("Error:", e.message);
      throw e.message;
    });
};

export const submitContractForServices = async () =>
  axios
    .post(`/api/candidate-account/contract-for-services`)
    .then((res) => res.data)
    .catch((e) => {
      console.error("Error submitting contract for services:", e.message);
      return e.message;
    });

export const submitClientForm = async (formData) =>
  axios
    .post(`/api/candidate-account/client-forms`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((res) => res.data)
    .catch((e) => {
      console.error("Error submitting client form:", e.message);
      return e.message;
    });

export const downloadFormDocument = async (url, filename) =>
  axios
    .get(`/api/candidate-account/form-document`, {
      params: {
        url: encodeURIComponent(url),
        filename,
      },
      responseType: "blob",
    })
    .then((res) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(res.data);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch((e) => {
      console.error("Error downloading document:", e.message);
      return e.message;
    });

export const downloadFormAttachmentContent = async (shortcode) =>
  axios
    .get(`/api/candidate-account/client-forms/attachment/content`, {
      params: { shortcode },
    })
    .then((res) => {
      return res.data;
    })
    .catch((e) => {
      console.error("Error downloading document:", e.message);
      return e.message;
    });

export const sendFeedbackReq = (score, comments, timesheetNumber) =>
  axios.post(`/api/candidate-account/timesheets/feedback`, {
    score,
    comments,
    timesheetNumber,
  });

// Personality test API functions
export const createPersonalityTest = () =>
  axios.post("/api/candidate-account/personality-test/create");

export const getPersonalityTestStatus = () =>
  axios.get("/api/candidate-account/personality-test/status");

export const navigatePersonalityTest = (
  token,
  direction,
  questionNumber,
  answer
) => {
  const csrfToken = getCSRFToken();
  return axios.post(
    `/my-account/personality-test/${token}/question_json`,
    {
      direction,
      question_number: String(questionNumber), // Convert to string
      answer: answer || "",
    },
    {
      headers: {
        "X-CSRF-Token": csrfToken,
      },
    }
  );
};
